import type { ApiClient } from './client';

export interface FeatureFlagsCatalogDomain {
  id: string;
  label: string;
  posture: 'shipped' | 'fail_closed' | 'fail_open' | string;
  admin_href: string;
  env_prefix?: string;
  writable_here?: boolean;
  shipped?: boolean;
  note?: string;
  flags: Record<string, boolean>;
}

export interface FeatureFlagsCatalog {
  domains: FeatureFlagsCatalogDomain[];
  shipped_keys?: string[];
  note?: string;
  kill_switches?: {
    posture: string;
    note: string;
    flags: Record<string, boolean>;
  };
  catalog_writable?: boolean;
}

export const featureFlagsCatalogMethods = {
  async adminFeatureFlagsCatalog(): Promise<FeatureFlagsCatalog> {
    const response = await this.makeRequest<FeatureFlagsCatalog>(
      this.getAdminEndpoint('/admin/feature_flags_catalog.php')
    );
    if (!response.success) {
      throw new Error(response.message || 'Failed to load feature flags catalog');
    }
    return (
      response.data || {
        domains: [],
        catalog_writable: false,
      }
    );
  },
} satisfies ThisType<ApiClient>;
